export const convertRateToStars = (vote: number | undefined) => {
  if (vote === undefined) return undefined
  return vote * 2 + 3
}
